import axiosInstance from '../axiosInterceptor/axiosInstance'

// Backend (BUS-2798 Social slice): GET /api/v1/orgs/{orgId}/social/accounts ->
// { connected, facebookConnected, instagramConnected }. orgId is passed in by the caller (the
// same value the React Query key is built from) so the request and its cache entry always agree;
// pass competitionId for a federation's per-competition account (omit for the org-level account).
const getAccountStatus = async ({ orgId, competitionId }) => {
  const url = competitionId
    ? `v1/orgs/${orgId}/social/accounts?competitionId=${competitionId}`
    : `v1/orgs/${orgId}/social/accounts`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getAccountStatus
